import { fetchBlogsByDestination } from '../../src/entities/Blogs/service';
import { fetchDestinations } from '../../src/common/service/api/Destination/Destination';
import { mapCommonPageItems } from '../../src/screens/CommonPage/service/mapperApi';

import { CommonPage, CommonPageProps } from '../../src/screens/CommonPage/ui/CommonPage';
import { GetStaticProps } from 'next';

export const getStaticProps: GetStaticProps<CommonPageProps> = async () => {
    try {
        const destinations = await fetchDestinations();
        const pageItems = await fetchBlogsByDestination(destinations);

        const itemDestinations = mapCommonPageItems(pageItems);

        return {
            props: {
                type: 'blog',
                destinations: itemDestinations,
                noLinkToDestination: true,
                upgradableList: true,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default CommonPage;
